import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import { ManageBannerForm } from '../../../components/SiteAdmin/ManageBanner';
import { restrictUrls } from '../../../helpers/adminPrivileges';
import messages from '../../../locale/messages';

function action({ store, intl, history }) {
  const title = intl.formatMessage(messages.addBanner);

  // From Redux Store
  let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
  let adminPrivileges = store.getState().account.privileges && store.getState().account.privileges.privileges;
  let privileges = store.getState().commonSettings && store.getState().commonSettings.privileges;

  if (!isAdminAuthenticated) {
    return { redirect: '/siteadmin/login' };
  }

  // Admin restriction
  // if (!restrictUrls('/siteadmin/banner/add', adminPrivileges, privileges)) {
  //   return { redirect: '/siteadmin' };
  // }

  return {
    title,
    component: (
      <AdminLayout>
        <ManageBannerForm mode="add" history={history} />
      </AdminLayout>
    ),
  };
}

export default action; 